var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.652 3.34769C16.2122 2.90791 15.4992 2.90791 15.0594 3.34769L7.52236 10.8847L7.52236 12.4773H9.11494L16.652 4.94027C17.0918 4.50049 17.0918 3.78747 16.652 3.34769ZM14.1038 2.39214C15.0714 1.42463 16.64 1.42463 17.6075 2.39214C18.575 3.35965 18.575 4.92831 17.6075 5.89582L9.87259 13.6308C9.74587 13.7575 9.57401 13.8287 9.39481 13.8287H6.84668C6.47352 13.8287 6.17101 13.5262 6.17101 13.153L6.17101 10.6049C6.17101 10.4257 6.24219 10.2538 6.36891 10.1271L14.1038 2.39214ZM4.14398 4.81966C3.52204 4.81966 3.01785 5.32384 3.01785 5.94578V15.8557C3.01785 16.4776 3.52204 16.9818 4.14398 16.9818H14.0539C14.6758 16.9818 15.18 16.4776 15.18 15.8557V11.3512C15.18 10.978 15.4825 10.6755 15.8557 10.6755C16.2289 10.6755 16.5314 10.978 16.5314 11.3512V15.8557C16.5314 17.224 15.4222 18.3332 14.0539 18.3332H4.14398C2.77571 18.3332 1.6665 17.224 1.6665 15.8557V5.94578C1.6665 4.57751 2.77571 3.46831 4.14398 3.46831H8.64848C9.02165 3.46831 9.32416 3.77082 9.32416 4.14398C9.32416 4.51715 9.02165 4.81966 8.64848 4.81966H4.14398Z",
    fill: "#4B4F5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkEdit);
export default __webpack_public_path__ + "static/media/dark-edit.7758f9ce3d8fced830f210e8ed165bfb.svg";
export { ForwardRef as ReactComponent };